class ProductConfigurator {

    constructor() {
        if (window.productConfiguratorInstance) {
            return window.productConfiguratorInstance;
        }


        this.configurators = $('body .pc-configurator-button');
        
        if (this.configurators.length) { 
            this.initConfigurators();
        }

        this.scrollManager = new ScrollManager();
        
        window.productConfiguratorInstance = this;
    }

    initConfigurators() {
        this.configurators.each((index, configurator) => {
            const $configurator = $(configurator);
            const configuratorId = $configurator.data('configurator-id');
            
            if (configuratorId) {
                this.popupManager = new PopupManager(configuratorId);

                this.init();
                this.bindEvents();

            }
        });
    }

    init() {
        this.popupManager.init();
    }

    bindEvents() {
        $(document).off('size-option-changed.configurator')
                  .on('size-option-changed.configurator', (e, value) => {
        });
    }

    showPreloader() {
        $('.pc-preloader').css('display', 'flex').fadeIn(300);
    }

    hidePreloader() {
        $('.pc-preloader').fadeOut(300);
    }
}